module.exports = __webpack_public_path__ + "media/img/uploads/event-featured-thumb-04-1d4bf3644deae510576f4883571fd823.jpg";